import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import NftCollectionsLayer from "../../components/NFT/NftCollectionsLayer";

const NftCollectionsPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="NFT Collections" />

                    <NftCollectionsLayer />
               </MasterLayout>
          </>
     );
};

export default NftCollectionsPage;
